var exports = {
  "az": "Box__tS5GAz",
  "wy": "Box_1__CgItLa",
  "m4": "Octicon__P5l_F2",
  "pv": "Box_2__UJkUrH",
};

module.exports = exports;
